import { shared } from "./shared";
import { auth } from "./auth";
import { users } from "./users";
import { rewards } from "./rewards";
import { trips } from "./trips";
import { successMsgs } from "./successMsgs";
import { faq } from "./faq";
import { verificationRequests } from "./verificationRequests";
import { admins } from "./admins";
import { referrals } from "./referrals";
import { offers } from "./offers";
import { animation } from "./animation";
import { serviceCenters } from "./serviceCenters";
import { challenges } from "./challenges";

const en = {
  serviceCenters,
  challenges,
  shared,
  auth,
  users,
  rewards,
  trips,
  successMsgs,
  faq,
  verificationRequests,
  admins,
  referrals,
  offers,
  animation,
};

export default en;
